import { combineEpics } from "redux-observable";
import { loadAnalysisRulesEpicReducer, deleteAnalysisRulesEpicReducer } from "../components/AnalysisConfigListContainer/List.epics.js";
const rootEpic = combineEpics(loadAnalysisRulesEpicReducer.epic, deleteAnalysisRulesEpicReducer.epic);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=AnalysisConfigList.epics.js.map
